import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';
import { API_ENDPOINTS } from '../../shared/constants/constants';
import { createContentService } from '../../shared/models/createContent';


export const createOrderContent = createAsyncThunk(
  'content/create',
  async (reqBody:any, {rejectWithValue}) => {
    const url = API_ENDPOINTS.createOrderContent;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getOrderContent = createAsyncThunk(
  'content/get',
  async (orderId:any, {rejectWithValue}) => {
    let url = API_ENDPOINTS.fetchOrderContent;
    url = url.replace(":orderId", orderId)
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(url);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createPartyContent = createAsyncThunk(
  'content/party/create',
  async (reqBody:createContentService, {rejectWithValue}) => {
    const url = API_ENDPOINTS.createPartyContent;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPartyContent = createAsyncThunk(
    'content/party/get',
    async (reqBody:any, {rejectWithValue}) => {
      // console.log(reqBody)
      let url = API_ENDPOINTS.getPartyContent;
      url = url.replace(":partyId",reqBody.partyId)
      url = url + `?purposeType=${reqBody.purposeType}`  
      url = reqBody?.status?url+`&status=true`:url;
      const { axiosGet } = useCustomAxios();
      try {
        const response = await axiosGet(url);
        return { data: response?.data, status: response?.status };
      } catch (error: any) {
        return rejectWithValue(error?.response?.data);
      }
    }
  );
export const fetchRequestItemsContentByContentIdApi = createAsyncThunk(
    'content/request/contentId/get',
    async (reqBody:any, {rejectWithValue}) => {

      const { axiosPost } = useCustomAxios();
      try {
        const response = await axiosPost(`${API_ENDPOINTS.fetchRequestItemContent}`, reqBody);
        return { data: response?.data, status: response?.status };
      } catch (error: any) {
        return rejectWithValue(error?.response?.data);
      }
    }
  );

  export const updateOrderContent = createAsyncThunk(
    'content/update',
    async (reqBody:any, {rejectWithValue}) => {
      const url = API_ENDPOINTS.updateOrderContent;
      const { axiosPost } = useCustomAxios();
      try {
        const response = await axiosPost(url, reqBody);
        return { data: response?.data, status: response?.status };
      } catch (error: any) {
        // console.log(error)
        return rejectWithValue(error?.response?.data);
      }
    }
  );

  export const createInvoiceContent = createAsyncThunk(
    'content/invoice/create',
    async (reqBody:any, {rejectWithValue}) => {
      const url = API_ENDPOINTS.createInvoiceContent;
      const { axiosPost } = useCustomAxios();
      try {
        const response = await axiosPost(url, reqBody);
        return { data: response?.data, status: response?.status };
      } catch (error: any) {
        console.log(error)
        return rejectWithValue(error?.response?.data);
      }
    }
  );
  
  export const getInvoiceContent = createAsyncThunk(
    'content/invoice/get',
    async (invoiceId:any, {rejectWithValue}) => {
      let url = API_ENDPOINTS.fetchInvoiceContent;
      url = url.replace(":invoiceId", invoiceId)
      const { axiosGet } = useCustomAxios();
      try {
        const response = await axiosGet(url);
        return { data: response?.data, status: response?.status };
      } catch (error: any) {
        console.log(error)
        return rejectWithValue(error?.response?.data);
      }
    }
  );
  
  export const updateInvoiceContent = createAsyncThunk(
    'content/invoice/update',
    async (reqBody:any, {rejectWithValue}) => {
      const url = API_ENDPOINTS.updateInvoiceContent;
      const { axiosPost } = useCustomAxios();
      try {
        const response = await axiosPost(url, reqBody);
        return { data: response?.data, status: response?.status };
      } catch (error: any) {
        // console.log(error)
        return rejectWithValue(error?.response?.data);
      }
    }
  );

export const createGoodsReqChallanContent = createAsyncThunk(
  'content/grn/create',
  async (reqBody:any, {rejectWithValue}) => {
    const url = API_ENDPOINTS.createGRNContent;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getGoodsReqChallanContent = createAsyncThunk(
  'content/grn/get',
  async (grnId:any, {rejectWithValue}) => {
    let url = API_ENDPOINTS.fetchGRNContent;
    url = url.replace(":goodsReqChallanId", grnId)
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(url);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error?.response?.data);
    }
  }
);